import React from 'react';
import { Upload, Form } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import notification from '../../../elements/lib/NotificationWrapper';
import { Translation, getI18n } from 'react-i18next';

// upload criteria
const fileTypesImage = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

const fileSizeLimit = 1024 * 1024 * 6;

const CoverImageUploadModule = ({
  form,
  uploadedCoverImage,
  setUploadedCoverImage,
}) => {
  const propsCoverImage = {
    multiple: false,
    onChange(info) {
      const fileList = info.fileList;
      setUploadedCoverImage(fileList);

      form.setFields([
        {
          name: ['cover_image'],
          cover_image: fileList,
        },
      ]);

      form.validateFields([['cover_image']]);
    },
    beforeUpload(file) {
      const isSupportedFileType = Object.keys(fileTypesImage).includes(
        file.type
      );
      if (!isSupportedFileType) {
        notification.error(
          getI18n().t('learning_admin_form_input_cover_image_file_types')
        );
        setUploadedCoverImage(null);
        return Upload.LIST_IGNORE;
      }
      const isUnderFileSizeLimit = file.size < fileSizeLimit;
      if (!isUnderFileSizeLimit) {
        notification.error(
          getI18n().t('learning_admin_form_input_image_file_size_limit')
        );
        setUploadedCoverImage(null);
        return Upload.LIST_IGNORE;
      }
      return false;
    },
  };

  const handleRemove = () => {
    setUploadedCoverImage(null);

    form.setFields([
      {
        name: ['cover_image'],
        cover_image: undefined,
      },
    ]);

    form.validateFields(['cover_image']);
  };

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <div
            className='ant-col ant-col-24 ant-form-item-label'
            style={{ paddingBottom: 0 }}
          >
            <label className='ant-form-item-required'>
              {t('learning_admin_form_input_cover_image')}
            </label>
          </div>
          <Form.Item
            name={'cover_image'}
            rules={[
              { required: true, message: 'Missing data for required field.' },
            ]}
          >
            {uploadedCoverImage === null || uploadedCoverImage.length === 0 ? (
              <Upload.Dragger {...propsCoverImage}>
                <p className='ant-upload-drag-icon'>
                  <InboxOutlined />
                </p>
                <p className='ant-upload-text'>
                  {t('learning_admin_form_input_image_drag_and_drop_upload')}
                </p>
                <p className='ant-upload-hint'>
                  {t(
                    'learning_admin_form_input_cover_image_drag_and_drop_types'
                  )}
                </p>
              </Upload.Dragger>
            ) : (
              <Upload
                className='upload-file'
                fileList={uploadedCoverImage}
                listType='picture'
                multiple={false}
                onRemove={handleRemove}
              />
            )}
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default CoverImageUploadModule;
